module.exports = __webpack_public_path__ + "static/media/rj.11a5c38f.jpg";